import { Component, inject, model } from '@angular/core';
import { ContractService } from '../services/contract.service';
import { ActivatedRoute } from '@angular/router';
import { AccessService } from '../../core/services/access.service';
import { ContractModel } from '../../shared/models/contract.model';
import { ContractFormComponent } from "../contract-form/contract-form.component";

@Component({
  selector: 'app-contrant-details',
  standalone: true,
  imports: [ContractFormComponent],
  templateUrl: './contract-details.component.html',
  styleUrl: './contract-details.component.css'
})
export class ContractDetailsComponent {
  private service = inject(ContractService);
  private route = inject(ActivatedRoute);
  protected access = inject(AccessService).access;

  protected id!: string | null;

  protected value = model<ContractModel | undefined>(undefined)

  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Detalles de Contrato')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.get(params.get('id'));
    });
  }

  private get(id: string | null) {
    console.log('getContract', id)
    if (id === null) {
      this.value.update((value) => (value = undefined));
    } else {
      // this.userService.userDetailed(userId);
      this.service.get(id).subscribe(data => {
        this.value.update(value => (value = data as ContractModel));
      });
    }
  }
}
